<section (appear)="startCounter()" class="counting-number__section">
  <div class="counting-number__container">
    <div class="counting-number__text">
      @if (title && !isFirstSection) {
        <h2 class="counting-number__text__title">
          <span class="counting-number__animate">
            <span>{{ currentValue }}</span>
          </span>
          @if (unit) {
            <span>{{ unit }}</span>
          }
        </h2>
      }
      @if (title && isFirstSection) {
        <h1 class="counting-number__text__title">
          <span class="counting-number__animate">
            <span>{{ currentValue }}</span>
          </span>
          @if (unit) {
            <span>{{ unit }}</span>
          }
        </h1>
      }
      @if (subtitle) {
        <h3 class="counting-number__text__subtitle" [innerHTML]="subtitle"></h3>
      }
    </div>
  </div>
</section>
